import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-offline-screen',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './offline-screen.component.html',
  styleUrl: './offline-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineScreenComponent {
  isOpen = input<boolean>(false);
  isRetrying = input<boolean>(false);

  retryClicked = output<void>();
  dismissClicked = output<void>();

  protected onRetry(): void {
    this.retryClicked.emit();
  }

  protected onDismiss(): void {
    this.dismissClicked.emit();
  }
}
